module.exports = __webpack_public_path__ + "static/media/paint-3.34c54638.jpg";